import { ProfileContent } from '../../components/popover/content/ProfileContent'
import { MainLayout } from '../../components/layout/MainLayout'

export function ProfilePage() {
  return (
    <MainLayout
      redirectOnSelect={false}
      hideBack={false}
      contentClassName="mt-0"
      className="h-screen min-h-auto"
      heightClassName="h-full"
    >
      <ProfileContent className="p-0 pb-5" />
    </MainLayout>
  )
}
